export const NAME_3_THINGS_TITLE = "Name 3 Things";
export const YOUR_FAVOURITE_TITLE = "Your Favourite Something";
export const CARDS_NAME_3_THINGS = [
  "Name 3 things that make you happy",
  "Name 3 things that make you sad",
  "Name 3 things you would like to have but can't afford",
  "Name 3 things you can't buy with money",
  "Name 3 things you would like to get for your birthday",
  "Name 3 things you can do in a park",
  "Name 3 excuses why you didn't do your homework",
  "Name 3 things you hope will happen in the future",
  "Name 3 radical sports you would like to try",
  "Name 3 things you can do in summer",
  "Name 3 things you can do in winter",
  "Name 3 things you buy with your pocket money",
  "Name 3 countries you would like to visit",
  "Name 3 things you can't stand",
  "Name 3 things you dislike about yourself",
  "Name 3 things you like about yourself",
  "Name 3 things that make a great holiday",
  "Name 3 things you are afraid of",
  "Name 3 unusual jobs",
  "Name 3 presents that you liked most",
  "Name 3 things you don't have the courage to do",
  "Name 3 things you shouldn't do at school",
  "Name 3 activities you like to do at the weekend",
  "Name 3 unusual pets",
  "Name 3 things you like about English",
  "Name 3 presents you didn't like at all",
  "Name 3 things you don't like about English",
  "Name 3 reasons why you would like to be a celebrity",
  "Name 3 reasons why you wouldn't like to be a celebrity",
  "Name 3 things to about a teacher",
];

export const PUZZLES_OBJECT = [
  { path: "/assets/images/puzzles/1.JPG", alt: "egogo", answer: "ready to go" },
  {
    path: "/assets/images/puzzles/Swarm.png",
    alt: "swarm",
    answer: "swarm of bees",
  },
  {
    path: "/assets/images/puzzles/pacific.png",
    alt: "pacific",
    answer: "a drop in the ocean",
  },
  {
    path: "/assets/images/puzzles/box.png",
    alt: "box",
    answer: "mailbox",
  },
  {
    path: "/assets/images/puzzles/world.png",
    alt: "world",
    answer: "around the world in eighty days",
  },
  {
    path: "/assets/images/puzzles/xqme.png",
    alt: "xqme",
    answer: "excuse me",
  },
  {
    path: "/assets/images/puzzles/bush.png",
    alt: "bush",
    answer: "beat around the bush",
  },
];
export const FAVS = [
  "Your favourite animal",
  "Your favourite board game",
  "Your favourite day of week",
  "Your favourite website",
  "Your favourite singer",
  "Your favourite drink",
  "Your favourite country",
  "Your favourite food",
  "Your favourite blogger",
  "Your favourite city",
  "Your favourite book",
  "Your favourite colour",
  "Your favourite film",
  "Your favourite cartoon",
  "Your favourite place",
  "Your favourite shop",
  "Your favourite subject",
  "Your favourite café",
  "Your favourite pet",
  "Your favourite snack",
  "Your favourite song",
  "Your favourite dessert",
  "Your favourite actor",
  "Your favourite actress",
  "Your favourite sport",
  "Your favourite flower",
  "Your favourite season",
  "Your favourite toy",
  "Your favourite music genre",
  "Your favourite friut",
  "Your favourite holiday",
  "Your favourite gadget",
  "Your favourite activity",
  "Your favourite number",
  "Your favourite computer game",
];

export const WORD_DATA = [
  {
    word: "windowsill",
    clue: "The flat part under a window, usually with some plants",
    category: "Home",
  },
  { word: "wall", clue: "The side of a room", category: "Home" },
  {
    word: "door",
    clue: "You use this to enter a room",
    category: "Home",
  },
  { word: "floor", clue: "You walk on this in a room", category: "Home" },
  {
    word: "ceiling",
    clue: "The top part of a room, opposite to floor",
    category: "Home",
  },
  {
    word: "wastebasket",
    clue: "You put trash in it",
    category: "Office",
  },
  {
    word: "socket",
    clue: "You put a plug in this to get electricity",
    category: "Electronics",
  },
  {
    word: "wire",
    clue: "A long, thin metal line for electricity",
    category: "Electronics",
  },
  {
    word: "plug",
    clue: "You put this in a socket to connect electricity",
    category: "Electronics",
  },
  {
    word: "calendar",
    clue: "You look at this to see the date",
    category: "Office",
  },
  {
    word: "desk",
    clue: "A table where you work or study",
    category: "Office",
  },
  { word: "chair", clue: "You sit on this", category: "Furniture" },
  {
    word: "bookcase",
    clue: "A piece of furniture for books",
    category: "Furniture",
  },
  {
    word: "box",
    clue: "A container with four sides, usually made of cardboard",
    category: "General",
  },
  {
    word: "folder",
    clue: "You use this to keep papers together in the office or on your PC",
    category: "Office",
  },
  {
    word: "glue",
    clue: "A sticky liquid to join things",
    category: "Office",
  },
  {
    word: "highlighter",
    clue: "A bright pen to mark important text",
    category: "Office",
  },
  {
    word: "pen",
    clue: "You use this to write with ink",
    category: "Office",
  },
  {
    word: "pencil",
    clue: "You use this to write with graphite or to draw",
    category: "Office",
  },
  {
    word: "scissors",
    clue: "You use these to cut paper",
    category: "Office",
  },
  {
    word: "stapler",
    clue: "You use this to join papers with staples",
    category: "Office",
  },
  {
    word: "notebook",
    clue: "A book with empty pages for writing",
    category: "Office",
  },
  {
    word: "laptop",
    clue: "A small computer you can carry",
    category: "Electronics",
  },
  {
    word: "printer",
    clue: "A machine that makes copies on paper",
    category: "Electronics",
  },
  {
    word: "usb drive",
    clue: "A small portable device to store computer files",
    category: "Electronics",
  },
  {
    word: "calculator",
    clue: "A machine that does maths",
    category: "Electronics",
  },
  {
    word: "charger",
    clue: "You use this to give power to a battery or your cell phone",
    category: "Electronics",
  },
  {
    word: "plug in",
    clue: "To connect to electricity using a socket",
    category: "Electronics",
  },
  {
    word: "plug out",
    clue: "To disconnect from electricity",
    category: "Electronics",
  },
  {
    word: "switch on the light",
    clue: "To make the light work",
    category: "Home",
  },
  {
    word: "switch off the light",
    clue: "To stop the light working, make the room dark",
    category: "Home",
  },
  {
    word: "great-grandparents",
    clue: "The parents of your grandparents",
    category: "Family",
  },
  {
    word: "great-grandchildren",
    clue: "The children of your grandchildren",
    category: "Family",
  },
  {
    word: "grandparents",
    clue: "The parents of your parents",
    category: "Family",
  },
  {
    word: "grandchildren",
    clue: "The children of your children",
    category: "Family",
  },
  {
    word: "grandson",
    clue: "The son of your son or daughter",
    category: "Family",
  },
  {
    word: "granddaughter",
    clue: "The daughter of your son or daughter",
    category: "Family",
  },
  {
    word: "stepparent",
    clue: "The new husband or wife of your parent",
    category: "Family",
  },
  {
    word: "stepmother",
    clue: "The new wife of your father",
    category: "Family",
  },
  {
    word: "stepfather",
    clue: "The new husband of your mother",
    category: "Family",
  },
  {
    word: "stepchild",
    clue: "The child of your husband or wife from before",
    category: "Family",
  },
  {
    word: "stepbrother",
    clue: "The son of your stepparent from before",
    category: "Family",
  },
  {
    word: "stepsister",
    clue: "The daughter of your stepparent from before",
    category: "Family",
  },
  {
    word: "mother-in-law",
    clue: "The mother of your husband or wife",
    category: "Family",
  },
  {
    word: "father-in-law",
    clue: "The father of your husband or wife",
    category: "Family",
  },
  {
    word: "son-in-law",
    clue: "The husband of your daughter",
    category: "Family",
  },
  {
    word: "daughter-in-law",
    clue: "The wife of your son",
    category: "Family",
  },
  {
    word: "nephew",
    clue: "The son of your brother or sister",
    category: "Family",
  },
  {
    word: "niece",
    clue: "The daughter of your brother or sister",
    category: "Family",
  },
  {
    word: "cousin",
    clue: "The child of your aunt or uncle",
    category: "Family",
  },
  {
    word: "uncle",
    clue: "The brother of your parent",
    category: "Family",
  },
  { word: "aunt", clue: "The sister of your parent", category: "Family" },
  { word: "husband", clue: "A married man", category: "Family" },
  { word: "wife", clue: "A married woman", category: "Family" },
  { word: "spouse", clue: "Your husband or wife", category: "Family" },
  {
    word: "couple",
    clue: "Two people in a relationship",
    category: "Family",
  },
  {
    word: "married",
    clue: "Two people being a husband and a wife",
    category: "Family",
  },
  { word: "single", clue: "Not married", category: "Family" },
  { word: "divorced", clue: "Not married anymore", category: "Family" },
  {
    word: "widow",
    clue: "A woman whose husband has died",
    category: "Family",
  },
  {
    word: "widower",
    clue: "A man whose wife has died",
    category: "Family",
  },
  { word: "aunty", clue: "Another word for aunt", category: "Family" },
  { word: "auntie", clue: "Another word for aunt", category: "Family" },
  {
    word: "flat",
    clue: "A home in a building with other homes",
    category: "Home",
  },
  {
    word: "studio apartment",
    clue: "A small flat with one main room",
    category: "Home",
  },
  {
    word: "apartment building",
    clue: "A tall building with many homes/flats",
    category: "Home",
  },
  {
    word: "townhouse",
    clue: "A small,usually with 2-3 floors, narrow home joined to the others",
    category: "Home",
  },
  {
    word: "fire escape",
    clue: "Stairs outside a building for emergencies",
    category: "Home",
  },
  { word: "roof", clue: "The top of a building", category: "Home" },
  {
    word: "balcony",
    clue: "A small area outside a room",
    category: "Home",
  },
  {
    word: "staircase",
    clue: "A set of stairs inside a building, your neighbors often smoke there",
    category: "Home",
  },
  {
    word: "stairs",
    clue: "Steps to go up or down in a building",
    category: "Home",
  },
  {
    word: "elevator",
    clue: "A small room that moves between floors",
    category: "Home",
  },
  { word: "lift", clue: "Another word for elevator", category: "Home" },
  {
    word: "hallway",
    clue: "A long, narrow area inside a home",
    category: "Home",
  },
  {
    word: "basement",
    clue: "The floor under the ground floor",
    category: "Home",
  },
  {
    word: "sofa",
    clue: "A long, soft seat for many people",
    category: "Furniture",
  },
  { word: "couch", clue: "Another word for sofa", category: "Furniture" },
  {
    word: "armchair",
    clue: "A comfortable seat with parts for your arms",
    category: "Furniture",
  },
  {
    word: "cupboard",
    clue: "A piece of furniture with doors for storage cups, plates, dishes",
    category: "Furniture",
  },
  {
    word: "drawer",
    clue: "A box that slides in and out of furniture",
    category: "Furniture",
  },
  {
    word: "chest of drawers",
    clue: "A piece of furniture with many drawers; a dresser",
    category: "Furniture",
  },
  {
    word: "cabinet",
    clue: "A piece of furniture with shelves, usually in the kitchen or bathroom",
    category: "Furniture",
  },
  {
    word: "wall unit",
    clue: "Furniture that is on the wall, with a TV set in the middle",
    category: "Furniture",
  },
  {
    word: "carpet",
    clue: "Soft material on the floor",
    category: "Home",
  },
  { word: "rug", clue: "A small carpet, a mat", category: "Home" },
  {
    word: "coffee table",
    clue: "A low table in front of a sofa",
    category: "Furniture",
  },
  {
    word: "furniture",
    clue: "Things like tables, chairs, beds,...",
    category: "Furniture",
  },
  {
    word: "heating",
    clue: "A system to make a home warm",
    category: "Home",
  },
  {
    word: "radiator",
    clue: "A metal object that gets hot to warm a room",
    category: "Home",
  },
  { word: "AC", clue: "Short for air conditioner", category: "Home" },
  {
    word: "air conditioner",
    clue: "A machine that makes air cool",
    category: "Home",
  },
  {
    word: "chandelier",
    clue: "A big, decorative light that hangs",
    category: "Home",
  },
  {
    word: "buy",
    clue: "To get something by paying money",
    category: "Commerce",
  },
  {
    word: "sell",
    clue: "To give something for money",
    category: "Commerce",
  },
  { word: "cost", clue: "The price of something", category: "Commerce" },
  {
    word: "own my apartment",
    clue: "To have your home, not to rent it",
    category: "Home",
  },
  {
    word: "rent a flat",
    clue: "To pay, usually every month, to live in a home/apartment",
    category: "Home",
  },
  { word: "dish", clue: "A plate for food", category: "Food" },
  { word: "meat", clue: "Food from animals", category: "Food" },
  {
    word: "fish",
    clue: "An animal that lives in water, used as food",
    category: "Food",
  },
  {
    word: "vegetables",
    clue: "Food from plants like carrots and broccoli",
    category: "Food",
  },
  {
    word: "fruit",
    clue: "Sweet food from plants like apples and oranges",
    category: "Food",
  },
  {
    word: "dairy",
    clue: "Food from milk like cheese and yogurt",
    category: "Food",
  },
  {
    word: "grain",
    clue: "Food like rice, wheat, and oats",
    category: "Food",
  },
  {
    word: "green",
    clue: "A color opposite to red",
    category: "Food",
  },
  {
    word: "nuts",
    clue: "Hard food from plants like almonds and peanuts",
    category: "Food",
  },
  {
    word: "pastry",
    clue: "Sweet baked food like cakes and cookies",
    category: "Food",
  },
  {
    word: "fast food",
    clue: "Food that is quick to prepare and eat, like burgers or French fries",
    category: "Food",
  },
  { word: "sweets", clue: "Food with a lot of sugar", category: "Food" },
  { word: "drinks", clue: "Liquids you can drink", category: "Food" },
  {
    word: "herbs",
    clue: "Plants used to add flavor to food",
    category: "Food",
  },
  {
    word: "taste",
    clue: "How food feels in your mouth",
    category: "Food",
  },
  { word: "flavour", clue: "How something tastes", category: "Food" },
  { word: "tasty", clue: "Delicious", category: "Food" },
  {
    word: "delicious",
    clue: "Very good to eat, really tasty",
    category: "Food",
  },
  { word: "disgusting", clue: "Very bad to eat", category: "Food" },
  { word: "thirsty", clue: "Needing to drink", category: "Food" },
  { word: "hungry", clue: "Needing to eat", category: "Food" },
  { word: "tasteless", clue: "Having no taste, bland", category: "Food" },
  { word: "sweet", clue: "Tasting like sugar", category: "Food" },
  {
    word: "bitter",
    clue: "A strong, sharp taste like black coffee or dark chocolate",
    category: "Food",
  },
  { word: "salty", clue: "Tasting like salt", category: "Food" },
  {
    word: "spicy",
    clue: "Having a hot taste like chili",
    category: "Food",
  },
  { word: "sour", clue: "A sharp taste like lemon", category: "Food" },
  { word: "fried", clue: "Cooked in hot oil", category: "Cooking" },
  { word: "baked", clue: "Cooked in an oven", category: "Cooking" },
  {
    word: "boiled",
    clue: "Cooked in very hot water",
    category: "Cooking",
  },
  {
    word: "roasted",
    clue: "Cooked in an oven or over a fire",
    category: "Cooking",
  },
  {
    word: "stewed",
    clue: "Cooked slowly in liquid",
    category: "Cooking",
  },
  {
    word: "add",
    clue: "To put something with something else",
    category: "Cooking",
  },
  {
    word: "mix",
    clue: "To combine things together",
    category: "Cooking",
  },
  {
    word: "cook",
    clue: "To prepare food with heat",
    category: "Cooking",
  },
  {
    word: "make",
    clue: "To create or prepare something like tea, a sandwich, or a salad, without heat",
    category: "Cooking",
  },
  {
    word: "pour",
    clue: "To make liquid flow from a container",
    category: "Cooking",
  },
  {
    word: "insects",
    clue: "Small animals with six legs like ants and flies",
    category: "Animals",
  },
  {
    word: "farm animals",
    clue: "Cows, sheep, pigs, horses, etc.",
    category: "Animals",
  },
  {
    word: "domestic",
    clue: "Adjective, about animals that live with people",
    category: "Animals",
  },
  {
    word: "wild",
    clue: "Adjective, about animals that live in nature",
    category: "Animals",
  },
  {
    word: "pet",
    clue: "An animal that lives with a family",
    category: "Animals",
  },
  {
    word: "tail",
    clue: "The long part at the back of an animal",
    category: "Animals",
  },
  { word: "fur", clue: "The soft hair on animals", category: "Animals" },
  {
    word: "feather",
    clue: "What covers a bird's body",
    category: "Animals",
  },
  {
    word: "shell",
    clue: "The hard outside of some animals and clams",
    category: "Animals",
  },
  { word: "wing", clue: "What birds use to fly", category: "Animals" },
  {
    word: "whiskers",
    clue: "Long hairs near an animal's mouth",
    category: "Animals",
  },
  { word: "paw", clue: "An animal's foot", category: "Animals" },
  {
    word: "horn",
    clue: "A hard point on some animals' heads such as a bull or rhino",
    category: "Animals",
  },
  { word: "fin", clue: "What fish use to swim", category: "Animals" },
  {
    word: "poison",
    clue: "Something that can make you sick or die",
    category: "Animals",
  },
  { word: "poisonous", clue: "Having venom", category: "Animals" },
  {
    word: "forest",
    clue: "A place with many trees, bushes, mushrooms",
    category: "Nature",
  },
  {
    word: "tree",
    clue: "A tall plant with a wooden stem",
    category: "Nature",
  },
  { word: "ocean", clue: "A very big sea", category: "Nature" },
  {
    word: "river",
    clue: "A long, natural stream of water",
    category: "Nature",
  },
  {
    word: "lake",
    clue: "A large area of fresh water with land around it",
    category: "Nature",
  },
  {
    word: "pond",
    clue: "A small area of water, usually in a park",
    category: "Nature",
  },
  { word: "stream", clue: "A small river", category: "Nature" },
  {
    word: "grass",
    clue: "Green plants that cover the ground and cows eat it",
    category: "Nature",
  },
  {
    word: "island",
    clue: "Land with water all around it",
    category: "Nature",
  },
  {
    word: "cave",
    clue: "A large hole in a mountain or underground",
    category: "Nature",
  },
  {
    word: "beach",
    clue: "Sandy land next to the sea, you can sunbathe there",
    category: "Nature",
  },
  {
    word: "volcano",
    clue: "A mountain that sometimes has fire and hot rock, and can erupt",
    category: "Nature",
  },
  {
    word: "soil",
    clue: "The brown or black material under our feet that plants grow in",
    category: "Nature",
  },
  {
    word: "waterfall",
    clue: "Streams falling from a high place, a mountain",
    category: "Nature",
  },
  {
    word: "rainbow",
    clue: "Colors in the sky after rain",
    category: "Nature",
  },
  { word: "sunshine", clue: "Light from the sun", category: "Nature" },
  {
    word: "plant",
    clue: "A living thing that grows in the ground",
    category: "Nature",
  },
  { word: "bite", clue: "To cut with your teeth", category: "Actions" },
  {
    word: "sting",
    clue: "To hurt with a sharp point, like a bee",
    category: "Actions",
  },
  { word: "protect", clue: "To keep safe", category: "Actions" },
  { word: "invite", clue: "To ask someone to come", category: "Social" },
  {
    word: "ask someone about",
    clue: "To question somebody",
    category: "Social",
  },
  {
    word: "ask someone out",
    clue: "To invite somebody on a date",
    category: "Social",
  },
  {
    word: "meet",
    clue: "To come together with someone, you do it with friends in a cafe or park",
    category: "Social",
  },
  {
    word: "celebrate",
    clue: "To do something special for a happy event",
    category: "Social",
  },
  {
    word: "reserve a table for two",
    clue: "To ask a restaurant to keep a table for two people",
    category: "Dining",
  },
  { word: "eat out", clue: "To eat at a restaurant", category: "Dining" },
  {
    word: "offer",
    clue: "To ask if someone wants something, suggest",
    category: "Social",
  },
  {
    word: "order",
    clue: "To ask for food in a restaurant",
    category: "Dining",
  },
  {
    word: "choose",
    clue: "To pick between options",
    category: "General",
  },
  { word: "serve", clue: "To give food to people", category: "Dining" },
  {
    word: "bring",
    clue: "To take something to a place",
    category: "General",
  },
  {
    word: "recommend",
    clue: "To say something is good and why",
    category: "Social",
  },
  {
    word: "prefer",
    clue: "To like one thing more than another",
    category: "General",
  },
  {
    word: "have something for lunch",
    clue: "To eat something at midday",
    category: "Dining",
  },
  {
    word: "give a tip",
    clue: "To give extra money for good service",
    category: "Dining",
  },
  {
    word: "split the bill",
    clue: "To share the cost of a meal with friends or workmates",
    category: "Dining",
  },
  {
    word: "cuisine",
    clue: "A style of cooking of any country",
    category: "Food",
  },
  {
    word: "menu",
    clue: "A list of food, meals, dishes in a restaurant",
    category: "Dining",
  },
  {
    word: "main course",
    clue: "The most important part of a meal",
    category: "Dining",
  },
  {
    word: "side dish",
    clue: "A small food with the main food",
    category: "Dining",
  },
  {
    word: "appetizer",
    clue: "A small food before the main food",
    category: "Dining",
  },
  {
    word: "starter",
    clue: "A word for soups or salads on the menu, before the main dish",
    category: "Dining",
  },
  {
    word: "salad dressing",
    clue: "A liquid you put on salad",
    category: "Food",
  },
  { word: "beverage", clue: "A drink", category: "Food" },
  {
    word: "soft drinks",
    clue: "Sweet drinks without alcohol",
    category: "Food",
  },
  {
    word: "eatery",
    clue: "A place to eat, usually a cheap one",
    category: "Dining",
  },
  {
    word: "all-you-can-eat buffet",
    clue: "A meal where you can eat as much as you want",
    category: "Dining",
  },
  {
    word: "coffee to go",
    clue: "Coffee in a cup to take away",
    category: "Dining",
  },
  {
    word: "takeaway",
    clue: "UK: Food to eat at home",
    category: "Dining",
  },
  {
    word: "takeout",
    clue: "US: Food to eat at home",
    category: "Dining",
  },
  {
    word: "hospital",
    clue: "A place where sick people go to",
    category: "Health",
  },
  {
    word: "pharmacy",
    clue: "A place to get medicine",
    category: "Health",
  },
  {
    word: "drugstore",
    clue: "US: A place to get medicine",
    category: "Health",
  },
  {
    word: "doctor",
    clue: "A person who helps sick people and treats them",
    category: "Health",
  },
  {
    word: "nurse",
    clue: "A person who helps/assists doctors",
    category: "Health",
  },
  { word: "dentist", clue: "A doctor for teeth", category: "Health" },
  { word: "patient", clue: "A person who is sick", category: "Health" },
  {
    word: "a fever",
    clue: "When your body is too hot because you are sick, high temperature",
    category: "Health",
  },
  {
    word: "pain",
    clue: "The feeling when something hurts a lot, sharp",
    category: "Health",
  },
  {
    word: "ache",
    clue: "A continuous pain, usually not that sharp, but blant",
    category: "Health",
  },
  {
    word: "a stomachache",
    clue: "Pain in your belly/tummy",
    category: "Health",
  },
  { word: "a headache", clue: "Pain in your head", category: "Health" },
  { word: "a toothache", clue: "Pain in your teeth", category: "Health" },
  {
    word: "a sore throat",
    clue: "Pain in your throat",
    category: "Health",
  },
  {
    word: "a runny nose",
    clue: "When liquid comes from your nose",
    category: "Health",
  },
  {
    word: "disease",
    clue: "Usually about a contageous sickness",
    category: "Health",
  },
  {
    word: "the flu",
    clue: "A common sickness with fever and cough",
    category: "Health",
  },
  {
    word: "health",
    clue: "The condition of your body",
    category: "Health",
  },
  {
    word: "healthy",
    clue: "Good condition of your body after a check-up at clinic, or about good food",
    category: "Health",
  },
  {
    word: "unhealthy",
    clue: "Bad food or anything else for your body",
    category: "Health",
  },
  {
    word: "medicine",
    clue: "Something that helps sick people, that you can buy at a pharmacy",
    category: "Health",
  },
  { word: "tablet", clue: "A small, hard, round medicine", category: "Health" },
  { word: "drug", clue: "US: Another word for medicine", category: "Health" },
  {
    word: "give an injection",
    clue: "To put medicine in with a needle",
    category: "Health",
  },
  {
    word: "call the ambulance",
    clue: "To phone for emergency help",
    category: "Health",
  },
  { word: "be ill", clue: "To be sick", category: "Health" },
  { word: "be sick", clue: "To be ill or to vomit", category: "Health" },
  {
    word: "get sick with",
    clue: "To become ill with something",
    category: "Health",
  },
  {
    word: "catch a cold",
    clue: "To get a common illness with coughing, sneezing, usually people get it in autumn and spring",
    category: "Health",
  },
  {
    word: "get well",
    clue: "To become healthy again",
    category: "Health",
  },
  {
    word: "take a pill",
    clue: "To swallow medicine",
    category: "Health",
  },
  {
    word: "use",
    clue: "To do something with an object",
    category: "General",
  },
  {
    word: "go to the doctor",
    clue: "To visit a medical worker at hospital",
    category: "Health",
  },
  {
    word: "hotel",
    clue: "A place to stay when traveling",
    category: "Travel",
  },
  {
    word: "suite",
    clue: "A big and expensive room in a hotel",
    category: "Travel",
  },
  {
    word: "single room",
    clue: "A room for one person",
    category: "Travel",
  },
  {
    word: "double room",
    clue: "A room for two people",
    category: "Travel",
  },
  {
    word: "reception desk",
    clue: "The place where you check in at a hotel or get any information",
    category: "Travel",
  },
  {
    word: "room service",
    clue: "Food brought to your hotel room, cleaning",
    category: "Travel",
  },
  {
    word: "cleaning lady",
    clue: "A woman who tidies rooms at a hotel",
    category: "Travel",
  },
  {
    word: "bellboy",
    clue: "A person who carries bags in a hotel",
    category: "Travel",
  },
  {
    word: "guest",
    clue: "A person staying at a hotel",
    category: "Travel",
  },
  {
    word: "vacancy",
    clue: "A room/rooms available in a hotel",
    category: "Travel",
  },
  {
    word: "no vacancy",
    clue: "No rooms available in a hotel",
    category: "Travel",
  },
  {
    word: "passport",
    clue: "A document for traveling to other countries",
    category: "Travel",
  },
  {
    word: "luggage",
    clue: "UK: Bags you take traveling",
    category: "Travel",
  },
  {
    word: "baggage",
    clue: "US: Bags you take traveling",
    category: "Travel",
  },
  {
    word: "view",
    clue: "What you can see from a place",
    category: "Travel",
  },
  { word: "cosy", clue: "Warm and comfortable", category: "General" },
  { word: "neat", clue: "Tidy and clean", category: "General" },
  { word: "quiet", clue: "Making little or no noise", category: "General" },
  { word: "noisy", clue: "Loud and disturbing", category: "General" },
  {
    word: "convenient",
    clue: "Easy to use, reach, get or do",
    category: "General",
  },
  {
    word: "comfortable",
    clue: "Pleasant to use or wear",
    category: "General",
  },
  {
    word: "check in at a hotel",
    clue: "To arrive at a hotel and become its guest",
    category: "Travel",
  },
  {
    word: "check out of a hotel",
    clue: "To leave a hotel",
    category: "Travel",
  },
  { word: "leave", clue: "To go away from a place", category: "Travel" },
  { word: "stay", clue: "To remain in a place", category: "Travel" },
  {
    word: "complain about",
    clue: "To say you are not happy with something",
    category: "General",
  },
  {
    word: "book in advance",
    clue: "To reserve before you go",
    category: "Travel",
  },
  {
    word: "profession",
    clue: "A job that needs special training",
    category: "Work",
  },
  {
    word: "pickpocket",
    clue: "A person who steals from tourists in the streets",
    category: "Work",
  },
  { word: "soldier", clue: "A person in the army", category: "Work" },
  {
    word: "electrician",
    clue: "A person who works with wires and power",
    category: "Work",
  },
  {
    word: "accountant",
    clue: "A person who works with money",
    category: "Work",
  },
  {
    word: "lawyer",
    clue: "A person who protects people in a court",
    category: "Work",
  },
  {
    word: "supervisor",
    clue: "A person who watches other workers, a boss",
    category: "Work",
  },
  { word: "principal", clue: "The boss of a school", category: "Work" },
  {
    word: "scientist",
    clue: "A person who studies science",
    category: "Work",
  },
  {
    word: "computer programmer",
    clue: "A person who writes computer programs",
    category: "Work",
  },
  {
    word: "software specialist",
    clue: "A person who knows about computer programs",
    category: "Work",
  },
  {
    word: "web developer",
    clue: "A person who makes websites",
    category: "Work",
  },
  { word: "artist", clue: "A person who makes art, painter", category: "Work" },
  {
    word: "engineer",
    clue: "A person who builds machines or structures",
    category: "Work",
  },
  {
    word: "service engineer",
    clue: "A person who fixes machines",
    category: "Work",
  },
  { word: "mechanic", clue: "A person who fixes cars", category: "Work" },
  {
    word: "plumber",
    clue: "A person who fixes water pipes",
    category: "Work",
  },
  {
    word: "salesperson",
    clue: "A person who sells things",
    category: "Work",
  },
  {
    word: "lose",
    clue: "To not have something anymore",
    category: "General",
  },
  { word: "jobless", clue: "Without a job", category: "Work" },
  { word: "homeless", clue: "Without a home", category: "General" },
  { word: "work as a", clue: "To have a job as a_____", category: "Work" },
  {
    word: "look for a job",
    clue: "To try to find work",
    category: "Work",
  },
  { word: "find a job", clue: "To get work", category: "Work" },
  { word: "apply for a job", clue: "To ask for work", category: "Work" },

  { word: "become", clue: "To start to be", category: "General" },
];

export const HANGMAN_QUESTIONS = [
  { hint: "Day of week", answer: "tuesday" },
  { hint: "Trick or treat holiday", answer: "halloween" },
  { hint: "Short name for a policeman", answer: "cop" },
  { hint: "Liquid made out of fruits", answer: "juice" },
  { hint: "A device used for typing", answer: "keyboard" },
  {
    hint: "A big corporation known for its Windows operational system and some other software products",
    answer: "microsoft",
  },
  { hint: "A thing that transfers electric current", answer: "cable" },
  { hint: "Card game", answer: "poker" },
  { hint: "Substance that is made by bees", answer: "honey" },
  { hint: "That round bright thing in the sky", answer: "sun" },
  { hint: "Second planet from the Sun", answer: "venus" },
  {
    hint: "Arnold Schwarzenegger says: Get to the chopper! What is he talking about?",
    answer: "helicopter",
  },
  {
    hint: "Thing that beats scissors and gets beaten by paper",
    answer: "rock",
  },
  { hint: "Marty McFly's car", answer: "delorean" },
  { hint: "Some season of a year", answer: "summer" },
  { hint: "Man's best friend", answer: "dog" },
  { hint: "Who You Gonna Call?", answer: "ghostbusters" },
  {
    hint: "Thing that you usually use to make your teeth clean",
    answer: "toothbrush",
  },
  {
    hint: "Someone who is hardly noticed. Kind of the opposite of popular or the best, but not exactly the worst.",
    answer: "underdog",
  },
  { hint: "A machine that can make a choo-choo sound", answer: "train" },
  { hint: "Device that helps you hide from the rain", answer: "umbrella" },
  { hint: "Dial M for ____", answer: "murder" },
];

export const ALPHABET = Array.from(Array(26)).map((e, i) => {
  return {
    keycodeUpper: i + 65,
    keycodeLower: i + 97,
    letter: String.fromCharCode(i + 65),
  };
});
